<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
			@click="fha">
			返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>企业</span><span style="color:#D7230C;">大全</span></div>
							<div class="sm_pub">海量职位、人才</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">企业大全</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div style="width: 80%;min-height: 1150px;float: left;">
					<div style="width: 95%;margin-left: 1%;height: 250px;">
						<div style="width: 30%;height: 200px;margin-top: 15px;float: left;">
							<img v-lazy="'https://admin.shipoe360.com/public/'+contents.logo"
								style="width: 100%;height: 100%;" alt="">
						</div>
						<div style="width: 60%;margin-left: 2%;height: 200px;margin-top: 15px;float: left;">
							<div style="width: 100%;height: 100px;line-height: 50px;font-size: 24px;font-weight: 800;">
								{{contents.title}}
							</div>
							<div style="height: 50px;font-size: 12px;line-height: 13px;">
								主营产品:{{contents.mainsell}}
							</div>
							<div style="height: 50px;">
								<img @click="VRZT(contents.vrlink)" src="../../../imges/lebiao/jrsp.png"
									style="width: 28px;height: 28px;border-radius: 50%;margin-top: 11px;float: left;"
									alt="">
								<div @click="VRZT(contents.vrlink)"
									style="float: left;line-height: 50px;margin-left: 10px;">VR展厅</div>
								<img @click="VRZT(contents.guanlink)" src="../../../imges/lebiao/qy.png"
									style="width: 28px;height: 28px;border-radius: 50%;margin-top: 11px;float: left;margin-left: 15px;"
									alt="">
								<div @click="VRZT(contents.guanlink)"
									style="float: left;line-height: 50px;margin-left: 10px;">官方网站</div>
								<img @click="ZXSCA(contents.uid)" src="../../../imges/lebiao/qzzp.png"
									style="width: 28px;height: 28px;border-radius: 50%;margin-top: 11px;float: left;margin-left: 15px;"
									alt="">
								<div @click="ZXSCA(contents.uid)" style="float: left;line-height: 50px;margin-left: 10px;">
									产品详情</div>
							</div>
						</div>
					</div>
					<div style="width: 95%;margin-left: 1%;margin-top: 25px;">
						<div
							style="width: 100%;border-bottom: 1px solid #D7230C;height: 30px;line-height: 30px;font-weight: 800;">
							<div style="width: 5px;height: 30px;background-color: #D7230C;float: left;"></div><span
								style="margin-left: 10px;font-size: 20px;">基本信息</span>
						</div>
						<div style="width: 100%;margin-top: 10px;" v-html="contents.describtion">
						</div>
						<div style="width: 95%;margin: 0 auto;height: 50px;margin-top: 20px;">
							<div @click="sca"
								style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 45%;">
								<img class="scname" src="../../../imges/dsdsdsds/shoucang1.png"
									style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									收藏
								</div>
							</div>
							<div @click="getShareInfo"
								style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
								<img class="scname" src="../../../imges/dsdsdsds/weixin1.png"
									style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									微信
								</div>
							</div>
							<div @click="fxkj"
								style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
								<img class="scname" src="../../../imges/dsdsdsds/qqkongjian1.png"
									style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									空间
								</div>
							</div>
						</div>
					</div>
					<div style="width: 95%;margin-left: 1%;height: 200px;margin-top: 50px;">
						<div style="width: 50%;height: 200px;float: left;" @click="ztmnxd(contents)">
							<div
								style="width: 100%;border-bottom: 1px solid #D7230C;height: 30px;line-height: 30px;font-weight: 800;">
								<div style="width: 5px;height: 30px;background-color: #D7230C;float: left;"></div><span
									style="margin-left: 10px;font-size: 20px;">联系人</span>
							</div>
							<div class="1" v-show="contents.gs_lxr[0].lxr!='待添加' && contents.gs_lxr[0].lxr!=''"
								style="width: 100%;float: left;height: 200px;margin-left: 2%;overflow-y: scroll;">
								<!-- <div class="1" style="width: 130px;float: left;height: 190px;margin-left: 2%;background: #000;margin-top: 10px;" v-for="(item,index) in 4" :key="index"> -->
								<div class="1"
									style="width: 100%;height: 190px;margin-left: 2%;margin-top: 10px;border-bottom: 1px solid #999;"
									v-for="(item,index) in contents.gs_lxr" :key="index">
									<div style="width: 100px;height: 120px;margin: 0 auto;margin-top: 15px;">
										<img v-lazy="'https://admin.shipoe360.com/public/' +item.lxrpicture"
											style="width: 100%;height: 100%;" alt="">
									</div>
									<div v-show="xs"
										style="height: 15px;font-size: 12px;text-align: center;line-height: 15px;">
										<span>{{item.lxr}}</span>
									</div>
									<div v-show="bxs"
										style="height: 15px;font-size: 12px;text-align: center;line-height: 15px;">
										<span>{{`${item.lxr}`.substring(0,1)}}&nbsp; *&nbsp;*
											&nbsp;{{`${item.lxr}`.substring(3,4)}}</span>
									</div>
									<div style="height: 15px;font-size: 12px;text-align: center;line-height: 15px;">
										<span>{{item.zy}}</span>
									</div>
									<div v-show="xs"
										style="height: 15px;font-size: 12px;text-align: center;line-height: 15px;">
										<span>{{item.mbphone}}</span>
									</div>
									<div v-show="bxs"
										style="height: 15px;font-size: 12px;text-align: center;line-height: 15px;">
										<span>{{`${item.mbphone}`.substring(0,2)}}&nbsp; *&nbsp;*
											&nbsp;{{`${item.mbphone}`.substring(8,11)}}</span>
									</div>
								</div>
							</div>

							<!-- 待添加 -->

							<div class="1" v-show="contents.gs_lxr[0].lxr=='待添加' || contents.gs_lxr[0].lxr==''"
								style="width: 100%;float: left;height: 200px;margin-left: 2%;overflow-y: scroll;text-align: center;line-height: 200px;font-weight: 600;">
								<!-- <div class="1" style="width: 130px;float: left;height: 190px;margin-left: 2%;background: #000;margin-top: 10px;" v-for="(item,index) in 4" :key="index"> -->
								待添加
							</div>
						</div>
						<div style="width: 45%;height: 250px;float: left;margin-left: 2%;">
							<div
								style="width: 100%;border-bottom: 1px solid #D7230C;height: 30px;line-height: 30px;font-weight: 800;">
								<div style="width: 5px;height: 30px;background-color: #D7230C;float: left;"></div><span
									style="margin-left: 10px;font-size: 20px;">企业二维码</span>
							</div>
							<div style="width: 150px;height: 150px;margin: 0 auto;margin-top: 25px;">
								<img v-lazy="'https://admin.shipoe360.com/public/' +contents.qyewm"
									style="width: 100%;height: 100%;" alt="">
							</div>
						</div>
					</div>
				</div>
				<div style="width: 20%;height: 1150px;float: left;">
					<div style="width: 100%;height: 20px;">
					</div>
					<div
						style="width: 100%;border-bottom: 1px solid #D7230C;height: 30px;line-height: 30px;font-weight: 800;">
						<div style="width: 5px;height: 30px;background-color: #D7230C;float: left;"></div><span
							style="margin-left: 10px;font-size: 20px;">联系方式</span>
					</div>
					<div style="width: 100%;height: 20px;line-height: 20px;font-size: 12px;">座机:{{contents.phone}}</div>
					<div style="width: 100%;height: 20px;line-height: 20px;font-size: 12px;">传真:{{contents.fax}}</div>
					<div style="width: 100%;height: 20px;line-height: 20px;font-size: 12px;">邮箱:{{contents.mail}}</div>
					<div style="width: 100%;height: 20px;line-height: 20px;font-size: 12px;">地址:{{contents.address}}
					</div>
					<div
						style="width: 100%;border-bottom: 1px solid #D7230C;height: 30px;line-height: 30px;font-weight: 800;margin-top: 25px;">
						<div style="width: 5px;height: 30px;background-color: #D7230C;float: left;"></div><span
							style="margin-left: 10px;font-size: 20px;">船舶工程</span>
					</div>
					<div style="width: 100%;height: 400px;">
						<div @click="cnmlgb(item.id,item.title)" class="qbessq"
							style="width: 100%;height: 40px;line-height: 40px;font-size: 14px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
							v-for="(item,index) in cbgclist" :key="index">
							{{item.title}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
		<dashang ref="dashang"></dashang>
		<div class="popContainer" v-show="isShowQR" @click="gbgb">
			<vue-qr style="display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				Text: '',
				isShowQR: false, //二维码显示
				letData: true,
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				playerOptions: {
					playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
					autoplay: false, //如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "",
						src: '' //url地址          
						// src: "" //url地址
					}],
					poster: "", //你的封面地址
					// width: document.documentElement.clientWidth,
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						fullscreenToggle: true, //全屏按钮
					}
				},
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				contents: '',
				cbgclist: '',
				bxs: true,
				xs: false,
				sb: [{
						id: '0',
						type: 'vr',
						src: 'https://wxywcy.mzgtuan.com/project/15/'
					},
					{
						id: '1',
						type: 'img',
						src: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.sc.enterdesk.com%2Fedpic%2F22%2F5e%2F97%2F225e97af8bdba6ffed4e546645b7c58c.jpg&refer=http%3A%2F%2Fup.sc.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1655535320&t=cab6a3df811e24116a0d230c497e9996'
					},
					{
						id: '2',
						type: 'video',
						src: 'http://admin.shipoe360.com/public/uploads/files/20220517/1_20220517160652f5ba3.mp4'
					}
				]
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			gbgb() {
				this.isShowQR = false
				// $('#qrCodeUrl').html = ''
			},
			fxkj() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						image_url: [this.contents.picture],
						share_url: "https://www.shipoe360.com/#" + this.$route.path + '?id=' + this.id
					};
					//跳转地址
					location.replace(
						"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&pics=" +
						share.image_url.join("|") +
						"&summary=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			getShareInfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					if (this.letData) {
						let myhref = window.location.href
						console.log(myhref)
						this.Text = myhref
						this.isShowQR = true
						this.letData = false
					} else {
						this.isShowQR = true
					}
				} else {
					this.$router.replace('/login')
				}
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection', {
					uid: loginInfo.id,
					title: this.contents.title,
					picture: this.contents.picture,
					pc_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
					url_link: 'pages/companydetails/index?id=' + this.id,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else {
					this.$notify({
						title: '失败',
						message: res.data.msg,
						type: 'error'
					});
				}
			},
			fha() {
				console.log('返回上一层')
				this.$router.go(-1); //返回上一层
			},
			VRZT(o) {
				const url = o.indexOf("http") > -1 ? o : `http://${o}`
				window.open(url)
			},
			ZXSCA(sb) {

				console.log(sb)
				this.$router.push({
					path: `/cpxq?id=${sb}`
				})
			},
			cnmlgb(o, id) {
				console.log(o, id)
				this.$router.push({
					path: `/hyzxdetail?id=${o}&title=${id}`
				})
			},
			async ztmnxd(sb) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo == null) {
					this.$message.error('请先登录');
					this.$router.push({
						path: '/login'
					})
					return false;
				} else {
					let res = await http.post('api/picture/login_yz', {
						tid: sb.id,
						nologin_type: 'qydqlx',
						uid: loginInfo.id
					})
					if (res.data.code == 500) {
						this.$refs.dashang.DS_ck(20.00, '查看企业大全联系人', 'qydqlx', sb.id)
					} else {
						this.xs = true
						this.bxs = false
					}
				}
			}
		},
		async mounted() {
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data

			let res3 = await http.get('api/picture/pc_qy_detail', {
				id: this.id,
			})
			console.log(res3)
			this.contents = res3.data.data.data
			// let res1 = await http.post('api/qydb/qycontent', {
			// 	id: this.id,
			// })
			// console.log(res1)
			// this.contents = res1.data.data[0]

			let res2 = await http.post('api/Common/index', {
				model: 'industry',
				type: 'content',
				mid: '7',
				fid: '4',
				rows_limit: '10'
			})
			this.cbgclist = res2.data.data.list.data

			this.playerOptions.sources[0].src =
				'http://admin.shipoe360.com/public/uploads/files/20220517/1_20220517160652f5ba3.mp4'
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			vueQr,
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			//打赏
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}

	.qbessq:hover {
		color: blue;
		text-decoration: underline;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		clear: both;
		overflow: hidden;
		height: 100%;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 80%;
		float: left;
	}

	.top_bottom_B {
		width: 20%;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}

	.cnmbd /deep/ .el-carousel__container {
		height: 500px;
	}

	/* 遮罩层 */
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}
</style>
